module.exports = __webpack_public_path__ + "static/datastru-668abd0fbcdd69a301e811bc3fb4041b.png";